/* eslint-ignore */
// @ts-nocheck
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';

export const SelectEmailContainer = styled.div`
  width: 100%;
  height: 210px !important;
  overflow: scroll;
  ::-webkit-scrollbar-track {
    background: #d1d1d1;
  }
  ::-webkit-scrollbar {
    width: 6px;
    background: #2d8bfd;
  }
  ::-webkit-scrollbar-thumb {
    background: #2d8bfd;
  }
  overflow-x: hidden;
  @media (max-width: 350px) {
    width: 100% !important;
    overflow-x: scroll !important;
  }
`;

export const SelectPhoneContainer = styled.div`
  width: 100%;
  height: 210px !important;
  overflow: scroll;
  ::-webkit-scrollbar-track {
    background: #d1d1d1;
  }
  ::-webkit-scrollbar {
    width: 6px;
    background: #2d8bfd;
  }
  ::-webkit-scrollbar-thumb {
    background: #2d8bfd;
  }
  overflow-x: hidden;
  @media (max-width: 350px) {
    width: 100% !important;
    overflow-x: scroll !important;
  }
`;

export const Container = styled(Modal.Body)`
  background-color: #ffffff;
  border-radius: 20px;
  width: 100%;
  padding: 30px;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

export const Title = styled.span`
  font-size: 1.625rem;
  color: #074f8c;
  @media (max-width: 375px) {
    font-size: 1.4375rem;
  }
`;

export const BackButton = styled.span`
  font-size: 1.25rem;
  color: #074f8c;
  margin-right: 10px;
  margin-left: -3px;
  cursor: pointer;
  @media (max-width: 375px) {
    font-size: 1.125rem;
  }
`;

export const CloseIcon = styled.span`
  font-size: 1.25rem;
  margin-top: -15px;
  margin-right: -11px;
  color: #074f8c;
  cursor: pointer;
  @media (max-width: 370px) {
    font-size: 1.125rem;
  }
`;

export const Content = styled.span`
  font-size: 1rem;
  font-weight: 400;
  color: #4d565c;
  @media (max-width: 385px) {
    font-size: 0.875rem;
  }
`;

export const FieldsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 25px;
`;

export const Fields = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 400px) {
    width: 100%;
  }
`;

export const FindYourCode = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
`;

export const FindYourCodeText = styled.span`
  font-size: 0.875rem;
  color: #074f8c;
  font-weight: 100;
`;

export const FindYourCodeIcon = styled.span`
  font-size: 1.25rem;
  color: #f0b01b;
  margin-left: 5px;
`;

export const DocumentContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const FormHeader = styled.div`
  width: 100%;
  @media (max-width: 768px) {
    position: absolute;
    top: -171px;
  }

  h2 {
    font-size: 1.4375rem;
    color: #005ca5;
    font-weight: 500;
    margin-bottom: 12px;
    @media (max-width: 768px) {
      font-size: 1.125rem;
      color: rgba(255, 255, 255, 0.9);
      margin-left: -5px;
      margin-right: -5px;

      br {
        display: none;
      }
    }
  }

  h3 {
    font-size: 0.9375rem;
    color: #7a7a7a;
    max-width: 350px;
    margin-bottom: 18px;
    @media (max-width: 768px) {
      color: #c9dfff;
      font-size: 0.8125rem;
      margin-left: -5px;
      margin-right: -5px;
    }
  }
`;

export const FormBox = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  overflow: hidden;
  justify-content: flex-start;
  flex-direction: column;

  @media (max-width: 768px) {
    justify-content: center;
    align-items: center;
    padding-top: 30px;
  }

  form {
    width: 100%;
    max-width: 400px;
    margin-top: 10px;

    @media (max-width: 768px) {
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
  }

  h4 {
    font-size: 16px;
    font-weight: 900;
    color: '#272727';
    margin-top: 10px;
    margin-bottom: 15px;
  }
`;

export const ListLoader = styled.div``;

export const AddressWrapper = styled.div`
  max-width: 400px;
`;

export const AdressItem = styled.label`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: 0px 0px 8px #80808024;
  background: #ffffff;
  border-radius: 7px;
  margin-bottom: 10px;
  padding: 15px 10px 15px 0px;
  border: 1px solid
    ${(props) => (props.border ? props.theme.colors.darkPurple : '#ffffff')};
  @media (max-width: 991px) {
    margin-top: 20px;
    padding: 15px 10px 15px 10px;
  }
`;

export const AdressLineContainer = styled.div``;

export const AdressLine = styled.div`
  font-size: 14px;
  color: ${(props) =>
    props.color ? props.theme.colors.darkPurple : '#4D565C'};
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
  @media (max-width: 991px) {
    font-size: 0.9375rem;
    width: 100%;
    text-overflow: initial;
    white-space: break-spaces;
  }
`;

export const AdressName = styled.span`
  font-size: 1.125rem;
  color: #4d565c;
  @media (max-width: 991px) {
    font-size: 1rem;
  }
`;

export const AdressIcon = styled.span`
  font-size: 1.5625rem;
  color: #f0b01b;
  margin-right: 5px;
  @media (max-width: 991px) {
    font-size: 1.25rem;
  }
`;

export const AdressNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  > div {
    font-weight: bold;
  }
`;

export const Select = styled.input`
  margin: 0 20px;
`;

export const AdressInfoContainer = styled.div``;

export const Hr = styled.hr`
  width: 100%;
  height: 0.5px;
  color: #808495;
  margin-top: 20px;
`;

export const AdressTitleIcon = styled.span`
  font-size: 1.4375rem;
  color: #ffffff;
  margin-bottom: -20px;
  margin-right: 15px;
`;

export const AddressContainer = styled.div`
  height: 200px;
  width: 100%;
`;

export const AddressItemContainer = styled.div`
  overflow-x: hidden;
  overflow-y: scroll;
  ::-webkit-scrollbar-track {
    background-color: #ffffff;
  }
  ::-webkit-scrollbar {
    width: 3px;
    background: rgba(0, 0, 0, 0.071);
  }
  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.4);
  }
  overflow-x: hidden;
  height: 200px;
  max-width: 100%;
  width: 485px;
  padding-right: 20px;
`;

export const AddressButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
  max-width: 100%;
  width: 465px;
  @media (max-width: 1850px) {
    margin-top: 20px;
  }
`;
